import React, { useState, useEffect } from 'react';
import './App.css';
import GuruBarChart from './components/GuruBarChart/GuruBarChart';
import GuruTradesChart from './components/GuruTradesChart/GuruTradesChart';
import Financial from './components/Financial/Financial';
import CashChart from './components/CashChart/CashChart';
import HorizontalBarChart from './components/HorizontalBarChart/HorizontalBarChart';
import TradeChart from './components/TradeChart/TradeChart';
import ROIC from './components/ROIC/ROIC';
import RevenuePie from './components/RevenuePie/RevenuePie';
import GeographicPie from './components/GeographicPie/GeographicPie';
import RadarChartData from './components/RadarChart/RadarChart';
import InsiderTradeLine from './components/InsiderTradeLine/InsiderTradeLine';
import SankeyChart from './components/SankeyChart/SankeyChart';
import StockChart from './components/StockChart/StockChart';
import FinancialStrength from './components/FinancialStrength/FinancialStrength';
import FlowChart from './components/FLowChart/FLowChart';
import { PropagateLoader } from 'react-spinners';  // Import PropagateLoader

const App = () => {
  const [loadedCharts, setLoadedCharts] = useState([<GuruBarChart />]);
  const [loading, setLoading] = useState(false); // Loading state for loader visibility
  const chartComponents = [
    <GuruBarChart />,
    <GuruTradesChart />,
    <Financial />,
    <CashChart />,
    <HorizontalBarChart />,
    <TradeChart />,
    <ROIC />,
    <RevenuePie />,
    <GeographicPie />,
    <RadarChartData />,
    <InsiderTradeLine />,
    <SankeyChart />,
    <StockChart />,
    <FlowChart />,
    <FinancialStrength />,
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.scrollHeight) {
        if (loadedCharts.length < chartComponents.length && !loading) {
          setLoading(true); // Show loader
          setTimeout(() => {
            setLoadedCharts(prev => [...prev, chartComponents[loadedCharts.length]]);
            setLoading(false); // Hide loader after adding new chart
          }, 1000); // Simulate a network delay
        }
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loadedCharts, loading, chartComponents]);

  return (
    <>
      <div style={{ minHeight: '100vh' }}>
        {/* Render loaded charts */}
        {loadedCharts.map((ChartComponent, index) => (
          <div key={index} style={{ margin: '4px 0', padding: '10px' }}>
            {ChartComponent}
          </div>
        ))}

        {/* Show loader when loading */}
        {loading && (
          <div style={{
            position: 'fixed',
            bottom: '40px', // Adjusted for better visibility
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
          }}>
            <PropagateLoader color="#4CAF50" size={23} /> {/* Blue loader */}
          </div>
        )}
      </div>

      {/* <p className="footer">Developed by Shahid Ayyub</p> */}
    </>
  );
};

export default App;
